import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex w-full text-right justify-end" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = {
  class: "absolute inset-0 flex items-center z-0",
  "aria-hidden": "true"
}

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';



export default /*@__PURE__*/_defineComponent({
  __name: 'StepGuide',
  props: {
    currentStep: {}
  },
  setup(__props: any) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
        return _createElementVNode("div", { key: index }, [
          _createElementVNode("div", {
            class: _normalizeClass(["relative text-center", [index < 6 ? 'pr-6' : 'pr-0']])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-0.5 w-full z-0", [index <= _ctx.currentStep ? 'bg-brand-primary' : 'bg-black']])
              }, null, 2)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["relative font-poppins z-20 w-6 h-6 rounded-full", [index <=  _ctx.currentStep ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark text-white' : 'bg-white border-solid border border-black text-black']])
            }, _toDisplayString(index), 3)
          ], 2)
        ])
      }), 64))
    ])
  ]))
}
}

})